import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./assets/stylesheets/index.css";
import { BrowserRouter } from "react-router";
import { Analytics } from "./components/analytics";
import { buildTreesponse } from "./collector";
import { isSupported, apply } from "invokers-polyfill/fn";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [],
});

if (!isSupported()) apply();

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Analytics />
    <App response={buildTreesponse()} />
  </BrowserRouter>,
);
